import React, { useMemo } from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import classNames from 'classnames';
// import useCheckIsMobile from '@/lib/hooks/useCheckIsMobile';
import { cn } from '@/lib/utils';

const ChooseContent = ({
  data,
}: {
  data?: {
    title?: string;
    imgPath?: string;

    parts?: {
      title?: string;
      desc?: string;
      imgPath?: string;
    }[];
  };
}) => {
  // const { isMobile } = useCheckIsMobile();
  //
  // const getTitle = useMemo(() => {
  //   return data?.title ? <div className={styles.title}>{data?.title}</div> : null;
  // }, [data?.title]);

  const getImage = useMemo(() => {
    return data?.imgPath ? (
      <div className={styles.img}>
        <Image src={data?.imgPath} alt={''} width={100} height={100} layout="responsive" objectFit="cover" />
      </div>
    ) : null;
  }, [data?.imgPath]);

  const getContent = () => {
    return (
      <div className={styles.content}>
        {data?.title && <h2 className="hidden">{data?.title}</h2>}

        <div className={cn(styles.title, 'md:hidden')}>{data?.title}</div>
        <div className={styles.mainContent}>
          {getImage}
          <div className={styles.contentList}>
            <div className={cn(styles.title, 'max-md:hidden')}>{data?.title}</div>
            {data?.parts?.length > 0 &&
              data?.parts?.map((item, index) => (
                <div className={styles.contentItem} key={index}>
                  <div className={classNames(styles.contentItemTitle)}>
                    <Image src={item.imgPath} alt={''} width={20} height={20} />
                    <h3 className={styles.subTitle}>{item.title}</h3>
                  </div>
                  <p className={styles.subDesc}>{item.desc}</p>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  };

  return <>{getContent()}</>;
};

export default ChooseContent;
